import BaseLayout from "@/layouts/BaseLayout.vue"
import EmptyLayout from "@/layouts/EmptyLayout.vue"
import SinglePageLayout from "@/layouts/SinglePageLayout.vue"
import type { Component } from "vue"

export enum Layouts {
  DEFAULT = "DEFAULT",
  SINGLE_PAGE = "SINGLE_PAGE",
  EMPTY = "EMPTY",
  SIDEBAR = "SIDEBAR",
  NATIVE = "NATIVE",
  CHAT = "CHAT",
}

export const SharedLayoutComponent: Record<Layouts, Component> = {
  [Layouts.DEFAULT]: BaseLayout,
  [Layouts.SINGLE_PAGE]: SinglePageLayout,
  [Layouts.EMPTY]: EmptyLayout,
  [Layouts.CHAT]: EmptyLayout,
  [Layouts.SIDEBAR]: EmptyLayout,
  [Layouts.NATIVE]: EmptyLayout,
}
